
const _directiveDependencies = [];
const _controllerDependencies = ['$state', '$scope', '$window'];

class NewsTabsController {

    constructor($state, $scope, $window) {

        const currentPath = $state.current.name;
        let threatsLandscapeRoute;

        const browser = $window.browserName.toLowerCase() + $window.browserVersion;

        if (browser !== 'ie11') {

            $scope.showThreatsTab = true;

        }

        if (currentPath.indexOf('.news') > -1) {

            threatsLandscapeRoute = 'root.dashboard.news.ltb';

        } else {

            threatsLandscapeRoute = 'root.dashboard.article.ltb';

        }
        $scope.openThreatsLandscape = () => {

            $state.go(threatsLandscapeRoute, {
                resourceId: 'news-lightbox',
                ltb: 'threats-landscape',
            });

        };

    }

}


class NewsTabsDirective {

    constructor() {

        this.template = require('./news-tabs.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push(($state, $scope, $window) =>
            new NewsTabsController($state, $scope, $window));
        this.controller = _controllerDependencies;
        this.controllerAs = 'newsTabsCtrl';

    }

}

_directiveDependencies.push(() => new NewsTabsDirective());


angular.module('directives')
    .directive('newsTabs', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/news-tabs/news-tabs.js